import React from 'react';
import { Card, CardContent, Checkbox, Grid, Typography, makeStyles } from '@material-ui/core';
import Image from '../common/Image';

const useStyles = makeStyles(() => ({
  cardMain: {
    height: '86px',
    width: '98%',
    marginTop: '5px',
    marginBottom: '6px',
    boxSizing: 'border-box',
    background: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #E4E7EC',
  },
  journeyThumbnail: {
    height: '60px',
    width: '48px',
    borderRadius: '4px',
  },
  primaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '134%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '250px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  publishDate: {
    fontWeight: 500,
    fontSize: '11px',
    color: '#667085',
    display: 'block',
    margin: '0',
    paddingLeft: '5px',
    marginTop: '5px',
  },
}));

export default function RuleJourneyItem({ journey, handleCheckBoxChange }) {
  const classes = useStyles();

  return (
    <Card className={classes.cardMain} variant="outlined" key={journey.id}>
      <CardContent>
        <Grid container direction="row">
          <Grid item xs={2}>
            <Checkbox
              checked={journey.checked}
              onChange={() => handleCheckBoxChange(journey.id)}
              name="checkedBox"
              color="primary"
            />
          </Grid>
          <Grid item xs={2}>
            <Image alt={journey.title} src={journey.thumbnail} className={classes.journeyThumbnail} />
          </Grid>
          <Grid item xs={8}>
            <Grid container direction="column">
              <Grid item xs={6}>
                <Typography className={classes.primaryText}>{journey.title}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.publishDate}>{journey.publishDate}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
